import React, { useState, useEffect } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { navi, Gnavi } from './service/dataarray'
import Swal from 'sweetalert2'

const Navi = ({ login, grade, setIsHeaderFixed, isHovered, setIsHovered }) => {
    const [naviList, setNaviList] = useState([])

    const NEEDSAI_URL = 'http://nzr.iptime.org:51234/'
    const NEEDSAINavItem = {
        label: 'NEEDS AI',
        value: 'NEEDS AI',
        path: NEEDSAI_URL,
    }

    useEffect(() => {
        let list = []

        if (grade && login) {
            list = Gnavi.filter(
                (navItem) => navItem.label !== 'MYMESSAGE' && !(navItem.label === 'ADMIN' && grade !== 1),
            )
        } else {
            list = navi.filter((navItem) => navItem.label !== 'MYMESSAGE' && navItem.label !== 'ADMIN')
        }

        const adminIndex = list.findIndex((v) => v.label === 'ADMIN')
        const aboutIndex = list.findIndex((v) => v.label === 'ABOUT')
        const hasNEEDSAI = list.some((v) => v.label === 'NEEDS AI')

        if (adminIndex !== -1 && aboutIndex !== -1 && !hasNEEDSAI) {
            list.splice(aboutIndex, 0, NEEDSAINavItem)
        }

        setNaviList(list)
    }, [grade, login])

    const handleMouseEnter = () => setIsHovered(true)
    const handleMouseLeave = () => setIsHovered(false)

    const showConfirm = () => {
        Swal.fire({
            title: '로그아웃 하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니요',
            confirmButtonText: '네',
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: '로그아웃 되었습니다!',
                    icon: 'success',
                })
                localStorage.clear()
                window.location.href = '/'
            }
        })
    }

    const testHandler = (event, path) => {
        if (!login && path === '/Mypage/Myprojects/myProject') {
            event.preventDefault()
            Swal.fire({
                title: '로그인 해주세요',
                icon: 'warning',
            })
        }
    }

    return (
        <ul
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={isHovered ? 'navi' : 'navi ohidden'}
        >
            {naviList.map((navItem, index) => (
                <li key={index}>
                    {navItem.label === 'NEEDS AI' ? (
                        <a href={navItem.path} target="_blank" rel="noopener noreferrer">
                            {navItem.label}
                        </a>
                    ) : (
                        <NavLink
                            to={navItem.path}
                            onClick={(e) => {
                                testHandler(e, navItem.path)

                                if (navItem.label === 'ADMIN') {
                                    e.preventDefault()
                                    window.location.href = navItem.path
                                }
                            }}
                            className={({ isActive }) =>
                                isActive && navItem.label !== 'NEEDS AI' ? 'active-link' : ''
                            }
                        >
                            {navItem.label}
                        </NavLink>
                    )}
                </li>
            ))}

            {!login ? (
                <li>
                    <Link to="/Login" className="btnstyle">
                        로그인
                    </Link>
                </li>
            ) : (
                <li>
                    <Link onClick={showConfirm} className="btnstyle">
                        로그아웃
                    </Link>
                </li>
            )}
        </ul>
    )
}

export default Navi
